import {InfrastructureError, InfrastructureErrorType} from "@app/core/shared/domain/infrastructure.error";

/**
 * Error thrown when an order is detected as duplicated
 */
export class DuplicatedOrderError implements InfrastructureError{
    name: string = '';
    message: string;
    _type = InfrastructureErrorType.BackendError;
    _error = null;

    constructor(message: string) {
        this.message = message;
    }


    stack = undefined;

    get error(): any {
        return this._error;
    }

    get type(): InfrastructureErrorType {
        return this._type;
    }
}